<template>
  <v-card flat class="tab-card-client">
    <cs-button
      id="newClient"
      class="create-new-client-button"
      label="Create New Client"
      primary
      @click="displayClientIndividualEditor('new', '')"
    ></cs-button>
    <v-row>
      <v-col cols="2" class="filter-by">FILTER BY:</v-col>
      <v-col cols="4">
        <v-text-field
          id="clientSearch"
          v-model="searchClientKeyword"
          placeholder="Search"
          color="primary"
          append-icon="mdi-magnify"
          class="excursion-filter-search excursion-input"
          single-line
          variant="underlined"
          type="text"
          @click:append="getClientFilterData(true)"
          @keyup.enter="getClientFilterData(true)"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table-server
      v-model:options="pagination"
      :headers="clientHeaders"
      :items="clientList"
      class="elevation-2 clients-table"
      :items-per-page-options="itemsPerPageOptions"
      :items-per-page="pagination.itemsPerPage"
      :items-length="clientListTotal"
      :loading="loading"
      color="primary"
      no-data-text="No client was found"
      density="comfortable"
      hover
    >
      <template #item="{ item }">
        <tr>
          <td class="clients-name-cell">
            <a
              id="updateClient"
              class="client-id-label"
              @click="displayClientIndividualEditor('update', item.sid)"
              >{{ item.sid }}</a
            >
          </td>
          <td class="text-left">{{ item.metadata.name }}</td>
          <td class="text-left">
            {{
              item.parent_client_metadata && item.parent_client_metadata.name
                ? item.parent_client_metadata.name
                : ''
            }}
          </td>
          <td class="text-left">
            <stb-icon-tooltip
              :id="getClientEnableButtonId(item.sid)"
              :icon-id="item.enabled ? 'fa:fas fa-check' : 'fa:fas fa-ban'"
              location="left"
              clickable
              icon-size="x-small"
              icon-color="rgb(119, 119, 119)"
              @click="
                displayClientEnabledConfirmationDialog(item.sid, item.enabled, item.metadata.name)
              "
            >
              <span v-if="item.enabled">Disable</span>
              <span v-if="!item.enabled">Enable</span>
            </stb-icon-tooltip>
            <stb-icon-tooltip
              :id="getClientMaintenanceModeButtonId(item.sid)"
              icon-id="fa:fas fa-wrench"
              location="left"
              clickable
              icon-size="x-small"
              :icon-color="item.maintenance_mode ? 'rgb(192, 7, 7)' : 'rgb(119, 119, 119)'"
              @click="
                displayClientMaintenanceModeConfirmationDialog(
                  item.sid,
                  item.maintenance_mode,
                  item.metadata.name
                )
              "
            >
              <span v-if="item.maintenance_mode">Disable</span>
              <span v-if="!item.maintenance_mode">Enable</span>
            </stb-icon-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table-server>
    <cs-form-dialog
      id="dlg-enable-client-confirmation"
      v-model="clientEnablementConfirmationDialogDisplayed"
      body-id="dlg-body-enable-client-confirmation"
      :heading="clientEnablementConfirmationDialogHeading"
      :primary-action="{
        label: clientEnablementConfirmationDialogButtonText,
        eventName: 'primary-click'
      }"
      :secondary-action1="{
        label: 'Cancel',
        eventName: 'secondary1-click'
      }"
      @primary-click="confirmClientEnabledToggle"
      @secondary1-click="clientEnablementConfirmationDialogDisplayed = false"
    >
      <template #cs-form-dialog-content>
        {{ clientEnablementConfirmationDialogContent }}
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="dlg-maintenance-mode-client-confirmation"
      v-model="clientMaintenanceModeConfirmationDialogDisplayed"
      body-id="dlg-body-maintenance-mode-client-confirmation"
      :heading="clientMaintenanceModeConfirmationDialogHeading"
      :primary-action="{
        label: clientMaintenanceModeConfirmationDialogButtonText,
        eventName: 'primary-click'
      }"
      :secondary-action1="{
        label: 'Cancel',
        eventName: 'secondary1-click'
      }"
      @primary-click="confirmClientMaintenanceModeToggle"
      @secondary1-click="clientMaintenanceModeConfirmationDialogDisplayed = false"
    >
      <template #cs-form-dialog-content>
        {{ clientMaintenanceModeConfirmationDialogContent }}
      </template>
    </cs-form-dialog>
  </v-card>
</template>

<script>
import * as types from '@/store/mutationTypes';

import clientTableColumn from '../lib/const/clientTableColumn';
import StbIconTooltip from './StbIconTooltip';

export default {
  name: 'ClientList',

  components: { StbIconTooltip },

  props: [],

  data() {
    return {
      clientEnablementConfirmationDialogDisplayed: false,
      clientEnablementConfirmationDialogContent: '',
      clientEnablementConfirmationDialogButtonText: '',
      clientEnablementConfirmationDialogClientSid: '',
      clientEnablementConfirmationDialogEnabled: true,
      clientMaintenanceModeConfirmationDialogDisplayed: false,
      clientMaintenanceModeConfirmationDialogContent: '',
      clientMaintenanceModeConfirmationDialogButtonText: '',
      clientMaintenanceModeConfirmationDialogClientSid: '',
      clientMaintenanceModeConfirmationDialogMaintenanceMode: false,
      querystringRefToTableColumnRefMap: {},
      tableColumnRefToQuerystringRefMap: {},
      search: '',
      itemsPerPageOptions: [
        { value: 10, title: '10' },
        { value: 30, title: '30' },
        { value: 50, title: '50' }
      ],
      pagination: {
        itemsPerPage: 30,
        page: 1,
        sortBy: ['']
      },
      clientHeaders: [
        {
          title: clientTableColumn.CLIENT_ID.label,
          key: clientTableColumn.CLIENT_ID.tableColumnRef,
          headerProps: { class: 'table-header' }
        },
        {
          title: clientTableColumn.CLIENT_NAME.label,
          key: clientTableColumn.CLIENT_NAME.tableColumnRef,
          headerProps: { class: 'table-header' }
        },
        {
          title: clientTableColumn.ORGANISATION_NAME.label,
          key: clientTableColumn.ORGANISATION_NAME.tableColumnRef,
          headerProps: { class: 'table-header' },
          sortable: false
        },
        {
          title: clientTableColumn.ACTION.label,
          key: clientTableColumn.ACTION.tableColumnRef,
          headerProps: { class: 'table-header' }
        }
      ],
      client: {},
      searchClientKeyword: '',
      clientModalType: 'new',
      clientModalClientSid: ''
    };
  },
  computed: {
    clientList() {
      return this.$store.state.common.clientList.data;
    },
    loading() {
      return this.$store.state.common.clientList.loading;
    },
    clientListTotal() {
      return this.$store.state.common.clientList.total;
    },
    clientEnablementConfirmationDialogHeading() {
      return `${this.clientEnablementConfirmationDialogButtonText} Client`;
    },
    clientMaintenanceModeConfirmationDialogHeading() {
      return `${this.clientMaintenanceModeConfirmationDialogButtonText} Maintenance Mode`;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getClientFilterData();
      },
      deep: true
    }
  },
  mounted() {
    Object.keys(clientTableColumn).forEach((key) => {
      this.querystringRefToTableColumnRefMap[clientTableColumn[key].querystringRef] =
        clientTableColumn[key].tableColumnRef;
      this.tableColumnRefToQuerystringRefMap[clientTableColumn[key].tableColumnRef] =
        clientTableColumn[key].querystringRef;
    });

    if (Object.keys(this.$route.query).length !== 0) {
      const {
        s: parsedSearchClientKeyword,
        page: parsedSearchPage,
        length: parsedSearchLength,
        direction: parsedSearchDirection,
        order: parsedSortBy
      } = this.$route.query;
      if (parsedSearchClientKeyword && String(parsedSearchClientKeyword).trim().length !== 0) {
        this.searchClientKeyword = parsedSearchClientKeyword;
      }
      if (
        parsedSearchLength === '10' ||
        parsedSearchLength === '30' ||
        parsedSearchLength === '50'
      ) {
        this.pagination.itemsPerPage = parseInt(parsedSearchLength, 10);
      } else {
        this.pagination.itemsPerPage = 30;
      }
      if (!Number.isNaN(parseInt(parsedSearchPage, 10)) && parseInt(parsedSearchPage, 10) > 0) {
        this.pagination.page = parseInt(parsedSearchPage, 10);
      }
      if (
        clientTableColumn.CLIENT_ID.querystringRef === parsedSortBy ||
        clientTableColumn.CLIENT_NAME.querystringRef === parsedSortBy ||
        clientTableColumn.ORGANISATION_NAME.querystringRef === parsedSortBy ||
        clientTableColumn.ACTION.querystringRef === parsedSortBy
      ) {
        this.pagination.sortBy[0] = {
          key: this.querystringRefToTableColumnRefMap[parsedSortBy],
          order: 'asc'
        };
        if (parsedSearchDirection === 'DESC' || parsedSearchDirection === 'ASC') {
          this.pagination.sortBy[0].order = parsedSearchDirection.toLowerCase();
        }
      }
    }
  },
  methods: {
    async getClientFilterData(pageResetTriggered = false) {
      if (pageResetTriggered) {
        this.resetPage();
      }

      this.$store.commit(types.COMMON_SET_CLIENT_LIST_LOADING, true);
      const filterParam = {
        s: this.searchClientKeyword,
        page: this.pagination.page,
        length: this.pagination.itemsPerPage
      };

      Object.keys(filterParam).forEach((key) => {
        if (filterParam[key] === '') {
          delete filterParam[key];
        }
      });
      const store = this.$store;
      const argHash = {
        stbApiAdapter: this.$app.stbApiAdapter,
        filterParam,
        store
      };

      const searchQuery = JSON.parse(JSON.stringify(filterParam));

      if (this.pagination.sortBy.length !== 0 && this.pagination.sortBy[0] !== '') {
        searchQuery.order = this.tableColumnRefToQuerystringRefMap[this.pagination.sortBy[0].key];
        filterParam.order = this.pagination.sortBy[0].key;
        if (this.pagination.sortBy[0].order) {
          searchQuery.direction = this.pagination.sortBy[0].order.toUpperCase();
          filterParam.direction = this.pagination.sortBy[0].order.toUpperCase();
        }
      }

      await this.$store.dispatch('common/getClientList', argHash);
      this.$router.replace({ query: searchQuery }, () => {});
    },
    async confirmClientEnabledToggle() {
      const store = this.$store;
      const requestParam = {
        enabled: this.clientEnablementConfirmationDialogEnabled
      };
      const argHash = {
        sid: this.clientEnablementConfirmationDialogClientSid,
        payload: requestParam,
        store: this.$store
      };

      const response = await this.$app.stbApiAdapter.putClientEnabled(argHash);

      if (!response.error) {
        store.dispatch(
          'common/toggleClientEnabled',
          this.clientEnablementConfirmationDialogClientSid
        );
      }

      this.clientEnablementConfirmationDialogDisplayed = false;
    },
    async confirmClientMaintenanceModeToggle() {
      try {
        const response = await this.$store.dispatch('clients/patchClientMaintenanceMode', {
          clientSid: this.clientMaintenanceModeConfirmationDialogClientSid,
          maintenanceMode: this.clientMaintenanceModeConfirmationDialogMaintenanceMode
        });

        if (response?.error) {
          this.$store.commit(types.COMMON_SET_IS_RESPONSE_WITH_ERROR, true);
          return;
        }

        this.$store.dispatch(
          'clients/toggleClientMaintenanceMode',
          this.clientMaintenanceModeConfirmationDialogClientSid
        );
      } catch {
        this.$store.commit(types.COMMON_SET_IS_RESPONSE_WITH_ERROR, true);
      } finally {
        this.clientMaintenanceModeConfirmationDialogDisplayed = false;
      }
    },
    async displayClientIndividualEditor(clientRecordExistenceType, clientSid) {
      const { axiosInstance, eventPluginCommonAdapter, stbApiAdapter } = this.$app;
      await this.$store.dispatch('authorisation/validateAndSetUserTokenOrLogout', {
        query: this.$route.query,
        axiosInstance
      });
      await this.$store.dispatch('common/initClientConfig', {
        eventPluginCommonAdapter,
        stbApiAdapter
      });
      if (clientRecordExistenceType === 'new') {
        this.$router.push('/admin/clients/new');
      } else {
        this.$router.push(`/admin/clients/${clientSid}`);
      }
    },
    displayClientEnabledConfirmationDialog(sid, enabled, clientName) {
      if (enabled) {
        this.clientEnablementConfirmationDialogContent = `You are disabling the client: ${clientName}, would you like to continue?`;
        this.clientEnablementConfirmationDialogButtonText = 'Disable';
      } else {
        this.clientEnablementConfirmationDialogContent = `You are about to enable ${clientName} as a client, would you like to continue?`;
        this.clientEnablementConfirmationDialogButtonText = 'Enable';
      }
      this.clientEnablementConfirmationDialogClientSid = sid;
      this.clientEnablementConfirmationDialogDisplayed = true;
      this.clientEnablementConfirmationDialogEnabled = !enabled;
    },
    displayClientMaintenanceModeConfirmationDialog(sid, maintenanceMode, clientName) {
      if (maintenanceMode) {
        this.clientMaintenanceModeConfirmationDialogContent = `You are disabling the maintenance mode for the client: ${clientName}, would you like to continue?`;
        this.clientMaintenanceModeConfirmationDialogButtonText = 'Disable';
      } else {
        this.clientMaintenanceModeConfirmationDialogContent = `You are about to enable maintenance mode for the client: ${clientName}, would you like to continue?\n This will prevent users from accessing the client site.`;
        this.clientMaintenanceModeConfirmationDialogButtonText = 'Enable';
      }
      this.clientMaintenanceModeConfirmationDialogClientSid = sid;
      this.clientMaintenanceModeConfirmationDialogDisplayed = true;
      this.clientMaintenanceModeConfirmationDialogMaintenanceMode = !maintenanceMode;
    },
    getClientEnableButtonId(sid) {
      return `client-list--client-enablement-confirmation-dialog-${sid}`;
    },
    getClientMaintenanceModeButtonId(sid) {
      return `client-list--client-maintenance-mode-confirmation-dialog-${sid}`;
    },
    resetPage() {
      this.pagination.itemsPerPage = 30;
      this.pagination.page = 1;
    }
  }
};
</script>

<style scoped>
.clients-name-cell a {
  color: #c80063;
  text-decoration: none;
  padding-left: 8px;
  cursor: pointer;
}

.clients-name-cell a:not([href]):not([tabindex]) {
  color: #c80063;
  text-decoration: none;
  padding-left: 8px;
}

.clients-table table.v-table > thead > tr > th:first-child {
  padding: 0 16px;
}

.clients-table :deep(.table-header) {
  font-size: 12px !important;
  font-weight: bolder !important;
  color: #000 !important;
  padding: 0 5px;
}

.clients-table tr td {
  font-size: 13px !important;
  font-weight: 400 !important;
  padding: 0 5px !important;
}
</style>
